import React from 'react';
import { Input } from '@heroui/react';

const NumberPairInput = ({ value = [0, 0], onChange,isDisabled=false }) => {
  const handleChange = (index, val) => {
    const num = Number(val);
    if (!isNaN(num)) {
      const newValue = [...value];
      newValue[index] = num;
      onChange(newValue);
    }
  };

  return (
    <div className="flex flex-row gap-2">
       <Input className="size-fit"
        type="number"
        value={value[0]}
        onChange={(e) => handleChange(0, e.target.value)}
        label="Max Swing Angle"
        isDisabled={isDisabled}
      />
      <Input className="size-fit"
        type="number"
        value={value[1]}
        onChange={(e) => handleChange(1, e.target.value)}
       label="Max Twist Angle"
       isDisabled={isDisabled}
      />
    </div>
  );
};
export default NumberPairInput;